import { render, staticRenderFns } from "./join-terms.vue?vue&type=template&id=d6f11d0a"
import script from "./join-terms.vue?vue&type=script&lang=ts"
export * from "./join-terms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports